
<div class="ngx-charts-bar-horizontal" #ganttContainer>
    <!-- linkable=true is what tells ngx-gantt to RENDER the arrows defined on
         each GanttItem's .links array. Without it the items still carry their
         dependency ids but no SVG path is drawn. The component's source has
         them under @Input linkable: boolean (default false). -->
    <ngx-gantt  #gantt (maxLevel)="3"
                (start)="viewOptions.start?.getDate()"
                (end)="viewOptions.end?.getDate()"
                [groups]="groups"
                [items]="items"
                [viewType]="viewType"
                [viewOptions]="viewOptions"
                [showToolbar]="true"
                [toolbarOptions]="toolbarOptions"
                [linkable]="true"
                (viewChange)="onViewChanged($event)"
                (barClick)="onBarClicked($event)"
            >
        <ngx-gantt-table (itemClick)="onItemClick($event)">
            <ngx-gantt-column name="Events" width="300px">
                <ng-template #range let-item="item" >               
                    <div (click)="onChildClicked(item)" class="clickable-cell" matTooltip="{{ item.title }} ({{ item.start | date:'shortTime' }} - {{ item.end | date:'shortTime' }})"></div>
                </ng-template>
                <ng-template #cell let-item="item">               
                    <div>{{ item.title }}</div>
                </ng-template>
                <!-- <ng-template #bar let-item="item"><div class="ganttLabel"> {{ item.start | date:'shortTime' }} - {{ item.end | date:'shortTime' }}</div></ng-template> -->
            </ngx-gantt-column>
        </ngx-gantt-table>

    </ngx-gantt>
</div>